import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { isInclusivelyAfterDay } from 'react-dates'
import Select from 'react-select'

import { isEmpty } from 'lodash'
import moment from 'moment'

import { colourStyles } from 'utils/selectStyle'
import iconAdd from 'images/add.svg'
import Col from 'component/utils/Col'
import DatePicker from 'component/utils/DatePicker'
import Field from 'component/utils/Field'
import Form from 'component/utils/Form'
import Modal from 'component/utils/Modal'
import ParcelRangeForm from './ParcelRangeForm'

const CARD_LIST = [{ value: 'Celebre', label: 'Celebre' }]

const FIELDS = [
  'cdDynamic',
  'cdPricebannerConfig',
  'dsCard',
  'dsDynamic',
  'dtPeriodEnd',
  'dtPeriodSt',
]

const SaveModal = ({
  closeModal,
  dynamicList,
  fields,
  initialValues,
  onSubmit,
  parcelList,
  setValueToField,
  title,
  translate,
  values,
}) => {
  const [parcelRangeList, setParcelRangeList] = useState(
    initialValues.parcelRangeList
  )

  const actualParcelList = parcelList.map((i) => ({
    value: i.cdParcel,
    label: i.dsParcel,
  }))

  const renderParcelRageForm = (item) => {
    const key = Object.keys(item)[0]

    return (
      <ParcelRangeForm
        dynamicList={dynamicList}
        initialValues={Object.values(item)[0]}
        key={key}
        onChange={(newValues) =>
          setParcelRangeList(
            parcelRangeList.map((i) =>
              Object.keys(i)[0] === key ? { [key]: newValues } : i
            )
          )
        }
        onClickRemoveButton={() =>
          setParcelRangeList(
            parcelRangeList.filter((i) => Object.keys(i)[0] !== key)
          )
        }
        parcelList={actualParcelList}
        showRemoveButton={key > 0}
        translate={translate}
        fieldsHighlight={fieldsHighlight(item)}
      />
    )
  }

  const fieldsHighlight = (item) => {
    const retValues = { cdParcel: 0, prMaxValue: 0, prMinValue: 0 }

    for (let index = 0; index < parcelRangeList.length; index++) {
      if (Object.keys(parcelRangeList[index])[0] === Object.keys(item)[0]) {
        const values = Object.values(parcelRangeList[index])[0]
        if (
          values &&
          values.prMinValue &&
          values.prMaxValue &&
          Number(formatDecimalValue(values.prMaxValue)) <=
            Number(formatDecimalValue(values.prMinValue))
        ) {
          retValues.prMaxValue = 1
        }

        if (index > 0 && values) {
          const valuesPrevious = Object.values(parcelRangeList[index - 1])[0]
          if (
            valuesPrevious &&
            values.prMinValue &&
            valuesPrevious.prMaxValue &&
            Number(formatDecimalValue(values.prMinValue)) <=
              Number(formatDecimalValue(valuesPrevious.prMaxValue))
          ) {
            retValues.prMinValue = 1
          }
        }

        for (let index2 = index - 1; index2 >= 0; index2--) {
          const valuesPrevious = Object.values(parcelRangeList[index2])[0]
          if (
            values &&
            valuesPrevious &&
            values.cdParcel === valuesPrevious.cdParcel
          ) {
            retValues.cdParcel = 1
          }
        }
      }
    }

    return retValues
  }

  const addParcelRangeToRender = () => {
    for (let i = 0; ; i++) {
      if (!parcelRangeList.some((j) => parseInt(Object.keys(j)[0], 10) >= i))
        return setParcelRangeList([
          ...parcelRangeList,
          {
            [i]: {
              cdParcel: 1,
              cdNewDynamic: '',
              prMaxValue: '',
              prMinValue: '',
            },
          },
        ])
    }
  }

  const isDisabled = () => {
    const firstParcelRange = parcelRangeList[0][0]
    const boolMinAndEqualPortionValue = checkMinimumAndEqualValueRule()

    return (
      !values.dsCard ||
      !values.cdDynamic ||
      !values.dtPeriodEnd ||
      !values.dtPeriodSt ||
      isEmpty(firstParcelRange) ||
      parcelRangeList
        .map((i) => Object.values(i)[0])
        .some((i) =>
          Object.entries(i).some((j) => {
            const current = j[1]

            if (j[0] === 'prMaxValue') {
              const { prMinValue } = i

              return (
                !current ||
                !prMinValue ||
                Number(formatDecimalValue(current)) <=
                  Number(formatDecimalValue(prMinValue))
              )
            }

            return !current
          })
        ) ||
      boolMinAndEqualPortionValue
    )
  }

  const checkMinimumAndEqualValueRule = () => {
    if (
      parcelRangeList.length > 1 &&
      parcelRangeList[0][0].prMaxValue &&
      parcelRangeList[0][0].prMaxValue.includes(',') &&
      parcelRangeList[0][0].cdParcel
    ) {
      let minValue = Number(
        formatDecimalValue(parcelRangeList[0][0].prMaxValue)
      )
      let minParcela = parcelRangeList[0][0].cdParcel
      let disable = false
      for (let index = 0; index < parcelRangeList.length; index++) {
        let secIndex = index
        let obj = parcelRangeList[index][secIndex]
        if (!obj) {
          while (!obj) {
            secIndex++
            obj = parcelRangeList[index][secIndex]
          }
        }
        if (
          obj &&
          obj.prMinValue &&
          obj.prMinValue.includes(',') &&
          obj.cdParcel
        ) {
          const prMinValueToCheck = Number(formatDecimalValue(obj.prMinValue))
          const minParcelaToCheck = obj.cdParcel
          if (
            (prMinValueToCheck <= minValue ||
              minParcelaToCheck <= minParcela) &&
            index !== 0
          ) {
            disable = true
          } else {
            minParcela = minParcelaToCheck
            if (obj.prMaxValue && obj.prMaxValue.includes(',')) {
              const prMaxValueToCheck = Number(
                formatDecimalValue(obj.prMaxValue)
              )
              if (prMaxValueToCheck > prMinValueToCheck) {
                minValue = prMaxValueToCheck
              }
            } else {
              disable = true
            }
          }
        } else {
          disable = true
        }
      }
      return disable
    }
  }

  const handleSubmit = () => {
    const submittedValues = {
      ...values,
      parcelRangeList: parcelRangeList.map((i) => {
        const parcelRange = Object.values(i)[0]

        const formattedParcelRange = {
          ...parcelRange,
          prMaxValue: formatDecimalValue(parcelRange.prMaxValue),
          prMinValue: formatDecimalValue(parcelRange.prMinValue),
        }

        return formattedParcelRange
      }),
    }

    onSubmit(submittedValues)
  }

  const formatDecimalValue = (value) =>
    value
      .replace(translate('delimiter.currency'), '')
      .replace(translate('separator.currency'), '.')

  return (
    <Modal size='lg' closeModal={closeModal}>
      <h2 className='pricebanner-config-modal-title'>
        <strong>{translate(title)}</strong>
      </h2>
      <Col xs={12} className='margin-top-double'>
        <div className='field-label'>
          <strong>
            {translate('config.pricebannerConfig.form.cdDynamicLabel')}
            <em>{translate('mandatory')}</em>
          </strong>
        </div>
        <Field {...fields.cdDynamic}>
          <Select
            {...fields.cdDynamic.input}
            className='react-select'
            classNamePrefix='react-select'
            onChange={(option) => {
              setValueToField(fields.cdDynamic.input.name, option.value)
              setValueToField(fields.dsDynamic.input.name, option.label)
            }}
            options={dynamicList}
            placeholder={translate(
              'config.pricebannerConfig.form.cdDynamicLabel2'
            )}
            styles={colourStyles}
            value={dynamicList.find((i) => i.value === values.cdDynamic)}
          />
        </Field>
      </Col>
      <Col xs={12}>
        <div className='field-label'>
          <strong>
            {translate('config.pricebannerConfig.form.dsCardLabel')}
            <em>{translate('mandatory')}</em>
          </strong>
        </div>
        <Field {...fields.dsCard}>
          <Select
            {...fields.dsCard.input}
            className='react-select'
            classNamePrefix='react-select'
            onChange={(option) =>
              setValueToField(fields.dsCard.input.name, option.value)
            }
            options={CARD_LIST}
            placeholder={translate(
              'config.pricebannerConfig.form.dsCardLabel2'
            )}
            styles={colourStyles}
            value={CARD_LIST.find((i) => i.value === values.dsCard)}
          />
        </Field>
      </Col>
      <Col xs={12}>
        <div className='field-label field-label-big'>
          <strong>
            {translate('config.pricebannerConfig.form.parcelRange')}
            <em>{translate('mandatory')}</em>
          </strong>
        </div>
        {parcelRangeList.map(renderParcelRageForm)}
        <Col xs={12} className='margin-top'>
          <div
            onClick={addParcelRangeToRender}
            className='flex index-add pricebanner-config-add'
          >
            <img src={iconAdd} />
            <legend>
              <strong>
                {translate(
                  'config.pricebannerConfig.form.addParcelRangeToRender'
                )}
              </strong>
            </legend>
          </div>
        </Col>
      </Col>
      <Col xs={12}>
        <div className='field-label field-label-big'>
          <strong>
            {translate('config.pricebannerConfig.form.dtPeriodLabel')}
          </strong>
        </div>
      </Col>
      <Col xs={6}>
        <div className='field-label'>
          <strong>
            {translate('config.pricebannerConfig.form.dtPeriodStLabel')}
          </strong>
        </div>
        <Field
          {...fields.dtPeriodSt}
          glyph='glyph glyph-calendar'
          className='margin-bottom-small'
        >
          <DatePicker
            {...fields.dtPeriodSt.input}
            id={fields.dtPeriodSt.input.name}
            isOutsideRange={(date) =>
              moment(date).isAfter(values.dtPeriodEnd) ||
              !isInclusivelyAfterDay(date, moment())
            }
            openUp='up'
            placeholder={translate(
              'config.pricebannerConfig.form.dtPeriodStLabel'
            )}
            scrollIntoView={false}
            showClearDate
          />
        </Field>
      </Col>
      <Col xs={6}>
        <div className='field-label'>
          <strong>
            {translate('config.pricebannerConfig.form.dtPeriodEndLabel')}
          </strong>
        </div>
        <Field
          {...fields.dtPeriodEnd}
          glyph='glyph glyph-calendar'
          className='margin-bottom-small'
        >
          <DatePicker
            {...fields.dtPeriodEnd.input}
            id={fields.dtPeriodEnd.input.name}
            isOutsideRange={(date) =>
              moment(date).isBefore(values.dtPeriodSt) ||
              !isInclusivelyAfterDay(date, moment())
            }
            openUp='up'
            placeholder={translate(
              'config.pricebannerConfig.form.dtPeriodEndLabel'
            )}
            scrollIntoView={false}
            showClearDate
          />
        </Field>
      </Col>
      <Col xsOffset={4} xs={4} className='margin-top-double'>
        <button
          disabled={isDisabled()}
          onClick={handleSubmit}
          type='button'
          className='button button-dark-mini full'
        >
          {translate('save_button_label')}
        </button>
      </Col>
    </Modal>
  )
}

SaveModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  dynamicList: PropTypes.array.isRequired,
  fields: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  parcelList: PropTypes.array.isRequired,
  setValueToField: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
}

export default Form({ fields: FIELDS })(SaveModal)
